// @ts-nocheck
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/react-in-jsx-scope */
export function FileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"
        fill="#5F6D83"
      />
    </svg>
  );
}

export function ExcelIcon() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 3.45312V0H0.75C0.334375 0 0 0.27168 0 0.609375V12.3906C0 12.7283 0.334375 13 0.75 13H11.25C11.6656 13 12 12.7283 12 12.3906V4.0625H7.75C7.3375 4.0625 7 3.78828 7 3.45312ZM8.87813 6.15723L7 8.53125L8.87813 10.9053C9.0375 11.1084 8.85938 11.375 8.5625 11.375H7.47188C7.33438 11.375 7.20625 11.3141 7.14062 11.215C6.52812 10.2959 6 9.4707 6 9.4707C5.8 9.84648 5.6875 9.97852 4.85625 11.2176C4.79062 11.3166 4.66562 11.3775 4.52812 11.3775H3.4375C3.14062 11.3775 2.9625 11.1109 3.12188 10.9078L5.00625 8.53379L3.12188 6.15977C2.95938 5.95664 3.14062 5.69004 3.4375 5.69004H4.525C4.6625 5.69004 4.79062 5.75098 4.85625 5.85C5.67187 7.08906 5.48125 6.70312 6 7.58926C6 7.58926 6.19063 7.29219 7.14375 5.85C7.20938 5.75098 7.3375 5.69004 7.475 5.69004H8.5625C8.85938 5.6875 9.0375 5.9541 8.87813 6.15723V6.15723ZM12 3.09512V3.25H8V0H8.19063C8.39063 0 8.58125 0.0634766 8.72188 0.177734L11.7812 2.66602C11.9219 2.78027 12 2.93516 12 3.09512Z"
        fill="#F44336"
      />
    </svg>
  );
}

export function VideoIcon() {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8889 4.5V1C10.8889 0.45 10.5389 0 10.1111 0H0.777778C0.35 0 0 0.45 0 1V11C0 11.55 0.35 12 0.777778 12H10.1111C10.5389 12 10.8889 11.55 10.8889 11V7.5L14 11.5V0.5L10.8889 4.5ZM8.55556 7H6.22222V10H4.66667V7H2.33333V5H4.66667V2H6.22222V5H8.55556V7Z"
        fill="#E13939"
      />
    </svg>
  );
}

export function ImageIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.75 11.9844V2.14062C13.75 1.36719 13.075 0.734375 12.25 0.734375H1.75C0.925 0.734375 0.25 1.36719 0.25 2.14062V11.9844C0.25 12.7578 0.925 13.3906 1.75 13.3906H12.25C13.075 13.3906 13.75 12.7578 13.75 11.9844ZM4.375 8.11719L6.25 10.2336L8.875 7.0625L12.25 11.2812H1.75L4.375 8.11719Z"
        fill="#F44336"
      />
    </svg>
  );
}
export const HelpIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.33331 11.0007H7.66665V9.66732H6.33331V11.0007ZM6.99998 0.333984C3.31998 0.333984 0.333313 3.32065 0.333313 7.00065C0.333313 10.6807 3.31998 13.6673 6.99998 13.6673C10.68 13.6673 13.6666 10.6807 13.6666 7.00065C13.6666 3.32065 10.68 0.333984 6.99998 0.333984ZM6.99998 12.334C4.05998 12.334 1.66665 9.94065 1.66665 7.00065C1.66665 4.06065 4.05998 1.66732 6.99998 1.66732C9.93998 1.66732 12.3333 4.06065 12.3333 7.00065C12.3333 9.94065 9.93998 12.334 6.99998 12.334ZM6.99998 3.00065C5.52665 3.00065 4.33331 4.19398 4.33331 5.66732H5.66665C5.66665 4.93398 6.26665 4.33398 6.99998 4.33398C7.73331 4.33398 8.33331 4.93398 8.33331 5.66732C8.33331 7.00065 6.33331 6.83398 6.33331 9.00065H7.66665C7.66665 7.50065 9.66665 7.33398 9.66665 5.66732C9.66665 4.19398 8.47331 3.00065 6.99998 3.00065Z"
      fill="#5F6D83"
    />
  </svg>
);
export const elementHelpIcon = (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.49996 0.166016C3.27996 0.166016 0.666626 2.77935 0.666626 5.99935C0.666626 9.21935 3.27996 11.8327 6.49996 11.8327C9.71996 11.8327 12.3333 9.21935 12.3333 5.99935C12.3333 2.77935 9.71996 0.166016 6.49996 0.166016ZM7.08329 10.0827H5.91663V8.91602H7.08329V10.0827ZM8.29079 5.56185L7.76579 6.09852C7.34579 6.52435 7.08329 6.87435 7.08329 7.74935H5.91663V7.45768C5.91663 6.81602 6.17913 6.23268 6.59913 5.80685L7.32246 5.07185C7.53829 4.86185 7.66663 4.57018 7.66663 4.24935C7.66663 3.60768 7.14163 3.08268 6.49996 3.08268C5.85829 3.08268 5.33329 3.60768 5.33329 4.24935H4.16663C4.16663 2.96018 5.21079 1.91602 6.49996 1.91602C7.78913 1.91602 8.83329 2.96018 8.83329 4.24935C8.83329 4.76268 8.62329 5.22935 8.29079 5.56185Z"
      fill="#5F6D83"
    />
  </svg>
);
export const DuplicateIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM19.5 21H8.5V7H19.5V21Z"
      fill="#5F6D83"
    />
  </svg>
);
export const DeleteIcon = (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z"
      fill="#5F6D83"
    />
  </svg>
);
export const SaveDraftIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.75 0.25H1.75C0.9175 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.9175 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V3.25L10.75 0.25ZM7 12.25C5.755 12.25 4.75 11.245 4.75 10C4.75 8.755 5.755 7.75 7 7.75C8.245 7.75 9.25 8.755 9.25 10C9.25 11.245 8.245 12.25 7 12.25ZM9.25 4.75H1.75V1.75H9.25V4.75Z"
      fill="#233759"
    />
  </svg>
);
export const VariconLogo = (
  <svg
    width="118"
    height="48"
    viewBox="0 0 118 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6327 30.0013C10.2377 30.6795 9.59319 30.6795 9.19818 30.0013L4.562 22.1297C4.16699 21.4515 4.47884 20.8966 5.28965 20.8966L14.5204 20.876C15.3104 20.876 15.6431 21.4309 15.2481 22.1092L10.6327 30.0013Z"
      fill="#233759"
    />
    <path
      d="M12.5249 33.6597C12.1922 34.2351 12.1922 35.16 12.5249 35.7149L17.265 43.8126C17.66 44.4908 18.3045 44.4908 18.6995 43.8126L41.423 4.78344C41.818 4.10521 41.4854 3.55029 40.6954 3.55029L31.2359 3.57085C30.5706 3.57085 29.7598 4.04355 29.4272 4.59847L12.5249 33.6597Z"
      fill="url(#paint0_linear_18_7598)"
    />
    <path
      d="M37.1606 21.1432C36.4121 21.1432 35.726 21.5337 35.3518 22.1708L23.1273 43.2166C22.8154 43.7715 23.2104 44.4497 23.8549 44.4497H24.8528L38.408 21.1638L37.1606 21.1432Z"
      fill="#F37921"
    />
    <path
      d="M112.898 21.1432H38.4076L24.8525 44.4292L112.898 44.3264C113.356 44.3264 113.73 43.9565 113.73 43.5043V21.9653C113.73 21.5132 113.356 21.1432 112.898 21.1432Z"
      fill="url(#paint1_linear_18_7598)"
    />
    <path
      d="M41.755 40.1542L38.2415 25.5825L38.2207 25.5003C38.2207 25.377 38.3039 25.3153 38.491 25.3153H40.965C41.1521 25.3153 41.2768 25.3975 41.2768 25.5414L43.335 35.9204C43.3558 35.9615 43.3766 35.9821 43.4182 35.9821C43.4598 35.9821 43.4806 35.9615 43.5014 35.9204L45.4556 25.5414C45.4764 25.377 45.5804 25.2948 45.7675 25.2948H48.1583C48.3662 25.2948 48.4494 25.3975 48.4078 25.5825L44.9151 40.1748C44.8735 40.3392 44.7696 40.4214 44.6032 40.4214H42.1084C41.9005 40.3803 41.7966 40.2981 41.755 40.1542Z"
      fill="white"
    />
    <path
      d="M55.4349 40.1337L54.9567 37.8729C54.9567 37.8112 54.9151 37.7701 54.8112 37.7701H51.2353C51.1313 37.7701 51.0898 37.8112 51.0898 37.8729L50.6324 40.1337C50.6116 40.2981 50.5076 40.3803 50.3205 40.3803H48.096C47.8673 40.3803 47.7842 40.2775 47.8257 40.0926L51.4224 25.5003C51.464 25.3359 51.5679 25.2537 51.7343 25.2537H54.333C54.5201 25.2537 54.6241 25.3359 54.6449 25.4798L58.2831 40.0515V40.1337C58.2831 40.257 58.2 40.3186 58.0129 40.3186H55.7467C55.5596 40.3597 55.4557 40.2775 55.4349 40.1337ZM51.6511 35.7971H54.3746C54.4786 35.7971 54.5201 35.756 54.4993 35.6943L53.0648 28.8915C53.044 28.8504 53.0232 28.8298 52.9817 28.8298C52.9401 28.8298 52.9193 28.8504 52.8985 28.8915L51.5056 35.7149C51.5264 35.756 51.5679 35.7971 51.6511 35.7971Z"
      fill="white"
    />
    <path
      d="M66.412 40.1337L64.3122 33.9474C64.2706 33.8857 64.229 33.8652 64.1875 33.8652H62.8985C62.8153 33.8652 62.7737 33.9063 62.7737 33.9679L62.7945 40.0926C62.7945 40.1542 62.7737 40.2159 62.7114 40.2775C62.649 40.3186 62.5866 40.3597 62.5035 40.3597H60.2581C60.175 40.3597 60.1126 40.3392 60.0502 40.2775C59.9879 40.2364 59.9671 40.1748 59.9671 40.0926L59.9463 25.5209C59.9463 25.4592 59.9671 25.3976 60.0295 25.3359C60.0918 25.2948 60.1542 25.2537 60.2374 25.2537H64.8319C65.7051 25.2537 66.4536 25.4387 67.1188 25.8086C67.7841 26.1786 68.3039 26.6924 68.6573 27.35C69.0107 28.0077 69.2186 28.7887 69.2186 29.6519C69.2186 30.5357 69.0315 31.3167 68.6365 31.9538C68.2415 32.6115 67.701 33.0842 66.9941 33.413C66.9317 33.4336 66.9109 33.4747 66.9109 33.5363L69.3226 40.0309C69.3434 40.0515 69.3434 40.0926 69.3434 40.1337C69.3434 40.257 69.2602 40.3186 69.0731 40.3186H66.7238C66.5783 40.3392 66.4744 40.2775 66.412 40.1337ZM62.7737 27.5145V31.8099C62.7737 31.8921 62.8153 31.9127 62.8985 31.9127H64.3954C64.9775 31.9127 65.4556 31.7072 65.8299 31.3167C66.2041 30.9056 66.3704 30.3713 66.3704 29.6725C66.3704 28.9737 66.1833 28.4393 65.8091 28.0283C65.4349 27.6172 64.9567 27.4117 64.3746 27.4117H62.8777C62.8153 27.4117 62.7737 27.4528 62.7737 27.5145Z"
      fill="white"
    />
    <path
      d="M71.3188 40.257C71.2564 40.2159 71.2356 40.1542 71.2356 40.072L71.2148 25.5003C71.2148 25.4386 71.2356 25.377 71.298 25.3153C71.3604 25.2742 71.4227 25.2331 71.5059 25.2331H73.7512C73.8344 25.2331 73.8967 25.2537 73.9591 25.3153C74.0215 25.3564 74.0423 25.4181 74.0423 25.5003L74.0631 40.072C74.0631 40.1337 74.0423 40.1953 73.9799 40.257C73.9175 40.2981 73.8552 40.3392 73.772 40.3392H71.5267C71.4435 40.3392 71.3812 40.3186 71.3188 40.257Z"
      fill="white"
    />
    <path
      d="M77.6806 39.3938C76.849 38.6539 76.4124 37.6674 76.4124 36.4548L76.3916 29.097C76.3916 27.8638 76.8074 26.8773 77.639 26.158C78.4706 25.4386 79.5933 25.0687 80.9862 25.0687C82.3791 25.0687 83.5226 25.4181 84.3542 26.158C85.2066 26.8773 85.6224 27.8638 85.6224 29.097V29.3642C85.6224 29.4464 85.6016 29.508 85.5392 29.5491C85.4768 29.6108 85.4145 29.6313 85.3313 29.6313L83.0652 29.7136C82.8781 29.7136 82.7741 29.6313 82.7741 29.4464V28.912C82.7741 28.4187 82.6078 28.0077 82.2752 27.6789C81.9425 27.3706 81.506 27.2062 80.9862 27.2062C80.4664 27.2062 80.0506 27.3706 79.718 27.6789C79.3854 27.9871 79.2398 28.3982 79.2398 28.912L79.2606 36.6397C79.2606 37.133 79.4269 37.544 79.7596 37.8729C80.0922 38.1812 80.508 38.3456 81.0278 38.3456C81.5683 38.3456 82.0049 38.1812 82.3168 37.8729C82.6494 37.5646 82.7949 37.1535 82.7949 36.6397V36.1054C82.7949 36.0437 82.8157 35.9821 82.8781 35.9204C82.9405 35.8793 83.0028 35.8382 83.086 35.8382L85.3521 35.9204C85.4353 35.9204 85.4976 35.9409 85.56 36.0026C85.6224 36.0437 85.6432 36.1054 85.6432 36.1876V36.4548C85.6432 37.6674 85.2274 38.6539 84.375 39.3938C83.5226 40.1337 82.3999 40.5036 81.007 40.5036C79.6348 40.5036 78.533 40.1337 77.6806 39.3938Z"
      fill="white"
    />
    <path
      d="M88.8859 39.3527C88.0336 38.6128 87.597 37.6057 87.597 36.3726L87.5762 29.1175C87.5762 27.8844 87.992 26.8979 88.8652 26.1374C89.7175 25.3975 90.8402 25.007 92.2539 25.007C93.6469 25.007 94.7903 25.377 95.6635 26.1169C96.5367 26.8568 96.9733 27.8638 96.9733 29.097L96.9941 36.352C96.9941 37.5852 96.5575 38.5922 95.7051 39.3321C94.8319 40.072 93.7092 40.4625 92.3163 40.4625C90.9234 40.4625 89.7383 40.1131 88.8859 39.3527ZM93.6261 37.8112C93.9587 37.4824 94.1458 37.0302 94.1458 36.4753L94.125 29.0148C94.125 28.4599 93.9587 28.0283 93.6053 27.6994C93.2519 27.3706 92.8153 27.1856 92.2539 27.1856C91.6926 27.1856 91.256 27.35 90.9234 27.6994C90.5907 28.0283 90.4244 28.4804 90.4244 29.0353L90.4452 36.4959C90.4452 37.0508 90.6115 37.4824 90.9442 37.8318C91.2768 38.1606 91.7134 38.3456 92.2747 38.3456C92.836 38.325 93.2726 38.1401 93.6261 37.8112Z"
      fill="white"
    />
    <path
      d="M106.329 25.2537C106.391 25.2126 106.454 25.1714 106.537 25.1714H108.761C108.844 25.1714 108.907 25.192 108.969 25.2537C109.032 25.2948 109.052 25.3564 109.052 25.4386L109.073 40.0103C109.073 40.072 109.052 40.1337 108.99 40.1953C108.928 40.2364 108.865 40.2775 108.782 40.2775H106.204C106.038 40.2775 105.934 40.2159 105.892 40.072L102.233 30.9261C102.212 30.885 102.192 30.8645 102.15 30.8645C102.108 30.8645 102.088 30.9056 102.088 30.9467L102.129 40.0309C102.129 40.0925 102.108 40.1542 102.046 40.2159C101.984 40.257 101.921 40.2981 101.838 40.2981H99.6136C99.5304 40.2981 99.4681 40.2775 99.4057 40.2159C99.3433 40.1748 99.3225 40.1131 99.3225 40.0309L99.3018 25.4592C99.3018 25.3975 99.3225 25.3359 99.3849 25.2742C99.4473 25.2331 99.5097 25.192 99.5928 25.192H102.108C102.275 25.192 102.379 25.2537 102.42 25.3975L106.1 34.4817C106.121 34.5228 106.142 34.5434 106.183 34.5434C106.225 34.5434 106.246 34.5023 106.246 34.4612L106.225 25.4386C106.246 25.377 106.266 25.3153 106.329 25.2537Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_18_7598"
        x1="10.1808"
        y1="34.1706"
        x2="44.9689"
        y2="8.60348"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F37921" />
        <stop offset="1" stopColor="#FBAD35" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_18_7598"
        x1="36.8128"
        y1="60.7244"
        x2="105.373"
        y2="10.3367"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#243859" />
        <stop offset="0.191" stopColor="#2C3959" />
        <stop offset="0.5025" stopColor="#3D3D58" />
        <stop offset="0.8935" stopColor="#554556" />
        <stop offset="1" stopColor="#5C4755" />
      </linearGradient>
    </defs>
  </svg>
);
export const FormFrame = (
  <svg
    width="64"
    height="52"
    viewBox="0 0 64 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.7497 0.833344H25.7497C24.833 0.833344 24.083 1.58334 24.083 2.50001V14.1667H25.7497V2.50001H35.7497V0.833344ZM34.9163 4.16668H29.083C28.1663 4.16668 27.4247 4.91668 27.4247 5.83334L27.4163 17.5C27.4163 18.4167 28.158 19.1667 29.0747 19.1667H38.2497C39.1663 19.1667 39.9163 18.4167 39.9163 17.5V9.16668L34.9163 4.16668ZM29.083 17.5V5.83334H34.083V10H38.2497V17.5H29.083Z"
      fill="#FBAD33"
    />
    <path
      d="M14.7617 32.0469V42H13.0459V32.0469H14.7617ZM18.8223 36.4014V37.7617H14.3242V36.4014H18.8223ZM19.3896 32.0469V33.4141H14.3242V32.0469H19.3896ZM29.1934 36.75V37.2969C29.1934 38.0488 29.0954 38.7233 28.8994 39.3203C28.7035 39.9173 28.4232 40.4255 28.0586 40.8447C27.6986 41.264 27.2656 41.5853 26.7598 41.8086C26.2539 42.0273 25.6934 42.1367 25.0781 42.1367C24.4674 42.1367 23.9092 42.0273 23.4033 41.8086C22.902 41.5853 22.4668 41.264 22.0977 40.8447C21.7285 40.4255 21.4414 39.9173 21.2363 39.3203C21.0358 38.7233 20.9355 38.0488 20.9355 37.2969V36.75C20.9355 35.998 21.0358 35.3258 21.2363 34.7334C21.4368 34.1364 21.7194 33.6283 22.084 33.209C22.4531 32.7852 22.8883 32.4639 23.3896 32.2451C23.8955 32.0218 24.4538 31.9102 25.0645 31.9102C25.6797 31.9102 26.2402 32.0218 26.7461 32.2451C27.252 32.4639 27.6872 32.7852 28.0518 33.209C28.4163 33.6283 28.6966 34.1364 28.8926 34.7334C29.0931 35.3258 29.1934 35.998 29.1934 36.75ZM27.4775 37.2969V36.7363C27.4775 36.1803 27.4229 35.6904 27.3135 35.2666C27.2087 34.8382 27.0514 34.4805 26.8418 34.1934C26.6367 33.9017 26.3838 33.6829 26.083 33.5371C25.7822 33.3867 25.4427 33.3115 25.0645 33.3115C24.6862 33.3115 24.349 33.3867 24.0527 33.5371C23.7565 33.6829 23.5036 33.9017 23.2939 34.1934C23.0889 34.4805 22.9316 34.8382 22.8223 35.2666C22.7129 35.6904 22.6582 36.1803 22.6582 36.7363V37.2969C22.6582 37.8529 22.7129 38.3451 22.8223 38.7734C22.9316 39.2018 23.0911 39.5641 23.3008 39.8604C23.515 40.152 23.7702 40.373 24.0664 40.5234C24.3626 40.6693 24.6999 40.7422 25.0781 40.7422C25.4609 40.7422 25.8005 40.6693 26.0967 40.5234C26.3929 40.373 26.6436 40.152 26.8486 39.8604C27.0537 39.5641 27.2087 39.2018 27.3135 38.7734C27.4229 38.3451 27.4775 37.8529 27.4775 37.2969ZM31.4092 32.0469H34.9297C35.6862 32.0469 36.3311 32.1608 36.8643 32.3887C37.3975 32.6165 37.8053 32.9538 38.0879 33.4004C38.375 33.8424 38.5186 34.3893 38.5186 35.041C38.5186 35.5378 38.4274 35.9753 38.2451 36.3535C38.0628 36.7318 37.8053 37.0508 37.4727 37.3105C37.14 37.5658 36.7435 37.764 36.2832 37.9053L35.7637 38.1582H32.5986L32.585 36.7979H34.957C35.3672 36.7979 35.709 36.7249 35.9824 36.5791C36.2559 36.4333 36.4609 36.235 36.5977 35.9844C36.7389 35.7292 36.8096 35.4421 36.8096 35.123C36.8096 34.7767 36.7412 34.4759 36.6045 34.2207C36.4723 33.9609 36.2673 33.7627 35.9893 33.626C35.7113 33.4847 35.3581 33.4141 34.9297 33.4141H33.125V42H31.4092V32.0469ZM37.0898 42L34.752 37.5293L36.5498 37.5225L38.9219 41.9111V42H37.0898ZM41.4248 32.0469H42.9561L45.834 39.7236L48.7051 32.0469H50.2363L46.4355 42H45.2188L41.4248 32.0469ZM40.7275 32.0469H42.1836L42.4365 38.6914V42H40.7275V32.0469ZM49.4775 32.0469H50.9404V42H49.2246V38.6914L49.4775 32.0469Z"
      fill="#F0840F"
    />
    <rect y="50" width="64" height="2" fill="#FBAD33" />
  </svg>
);
export const HeadingIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M17.5 20.5V23.5H22.5V35.5H25.5V23.5H30.5V20.5H17.5ZM36.5 25.5H27.5V28.5H30.5V35.5H33.5V28.5H36.5V25.5Z"
      fill="#FBAD33"
    />
  </svg>
);

export const InstructionIcon = (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" transform="translate(0.5)" fill="#FFF4E3" />
    <path
      d="M26.5 23H28.5V25H26.5V23ZM26.5 27H28.5V33H26.5V27ZM27.5 18C21.98 18 17.5 22.48 17.5 28C17.5 33.52 21.98 38 27.5 38C33.02 38 37.5 33.52 37.5 28C37.5 22.48 33.02 18 27.5 18ZM27.5 36C23.09 36 19.5 32.41 19.5 28C19.5 23.59 23.09 20 27.5 20C31.91 20 35.5 23.59 35.5 28C35.5 32.41 31.91 36 27.5 36Z"
      fill="#FBAD33"
    />
  </svg>
);
export const FullNameIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M27 21.9C28.16 21.9 29.1 22.84 29.1 24C29.1 25.16 28.16 26.1 27 26.1C25.84 26.1 24.9 25.16 24.9 24C24.9 22.84 25.84 21.9 27 21.9ZM27 30.9C29.97 30.9 33.1 32.36 33.1 33V34.1H20.9V33C20.9 32.36 24.03 30.9 27 30.9ZM27 20C24.79 20 23 21.79 23 24C23 26.21 24.79 28 27 28C29.21 28 31 26.21 31 24C31 21.79 29.21 20 27 20ZM27 29C24.33 29 19 30.34 19 33V36H35V33C35 30.34 29.67 29 27 29Z"
      fill="#FBAD33"
    />
  </svg>
);
export const EmailIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M37 22C37 20.9 36.1 20 35 20H19C17.9 20 17 20.9 17 22V34C17 35.1 17.9 36 19 36H35C36.1 36 37 35.1 37 34V22ZM35 22L27 27L19 22H35ZM35 34H19V24L27 29L35 24V34Z"
      fill="#FBAD33"
    />
  </svg>
);
export const AddressIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M27 18C23.13 18 20 21.13 20 25C20 30.25 27 38 27 38C27 38 34 30.25 34 25C34 21.13 30.87 18 27 18ZM22 25C22 22.24 24.24 20 27 20C29.76 20 32 22.24 32 25C32 27.88 29.12 32.19 27 34.88C24.92 32.21 22 27.85 22 25Z"
      fill="#FBAD33"
    />
    <path
      d="M27 27.5C28.3807 27.5 29.5 26.3807 29.5 25C29.5 23.6193 28.3807 22.5 27 22.5C25.6193 22.5 24.5 23.6193 24.5 25C24.5 26.3807 25.6193 27.5 27 27.5Z"
      fill="#FBAD33"
    />
  </svg>
);
export const PhoneIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M32.46 21C32.4 21.89 32.25 22.76 32.01 23.59L33.21 24.79C33.62 23.59 33.88 22.32 33.97 21H32.46ZM22.6 33.02C21.75 33.26 20.88 33.41 20 33.47V34.96C21.32 34.87 22.59 34.61 23.8 34.21L22.6 33.02ZM31.5 19H35C35.55 19 36 19.45 36 20C36 29.39 28.39 37 19 37C18.45 37 18 36.55 18 36V32.51C18 31.96 18.45 31.51 19 31.51C20.24 31.51 21.45 31.31 22.57 30.94C22.67 30.9 22.78 30.89 22.88 30.89C23.14 30.89 23.39 30.99 23.59 31.18L25.79 33.38C28.62 31.93 30.94 29.62 32.38 26.79L30.18 24.59C29.9 24.31 29.82 23.92 29.93 23.57C30.3 22.45 30.5 21.25 30.5 20C30.5 19.45 30.95 19 31.5 19Z"
      fill="#FBAD33"
    />
  </svg>
);

export const NumberIcon = (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" transform="translate(0.5)" fill="#FFF4E3" />
    <path
      d="M27.5 35C26.4 35 25.5 35.9 25.5 37C25.5 38.1 26.4 39 27.5 39C28.6 39 29.5 38.1 29.5 37C29.5 35.9 28.6 35 27.5 35ZM21.5 17C20.4 17 19.5 17.9 19.5 19C19.5 20.1 20.4 21 21.5 21C22.6 21 23.5 20.1 23.5 19C23.5 17.9 22.6 17 21.5 17ZM21.5 23C20.4 23 19.5 23.9 19.5 25C19.5 26.1 20.4 27 21.5 27C22.6 27 23.5 26.1 23.5 25C23.5 23.9 22.6 23 21.5 23ZM21.5 29C20.4 29 19.5 29.9 19.5 31C19.5 32.1 20.4 33 21.5 33C22.6 33 23.5 32.1 23.5 31C23.5 29.9 22.6 29 21.5 29ZM33.5 21C34.6 21 35.5 20.1 35.5 19C35.5 17.9 34.6 17 33.5 17C32.4 17 31.5 17.9 31.5 19C31.5 20.1 32.4 21 33.5 21ZM27.5 29C26.4 29 25.5 29.9 25.5 31C25.5 32.1 26.4 33 27.5 33C28.6 33 29.5 32.1 29.5 31C29.5 29.9 28.6 29 27.5 29ZM33.5 29C32.4 29 31.5 29.9 31.5 31C31.5 32.1 32.4 33 33.5 33C34.6 33 35.5 32.1 35.5 31C35.5 29.9 34.6 29 33.5 29ZM33.5 23C32.4 23 31.5 23.9 31.5 25C31.5 26.1 32.4 27 33.5 27C34.6 27 35.5 26.1 35.5 25C35.5 23.9 34.6 23 33.5 23ZM27.5 23C26.4 23 25.5 23.9 25.5 25C25.5 26.1 26.4 27 27.5 27C28.6 27 29.5 26.1 29.5 25C29.5 23.9 28.6 23 27.5 23ZM27.5 17C26.4 17 25.5 17.9 25.5 19C25.5 20.1 26.4 21 27.5 21C28.6 21 29.5 20.1 29.5 19C29.5 17.9 28.6 17 27.5 17Z"
      fill="#FBAD33"
    />
  </svg>
);
export const ShortTextIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M35 34L32 31V33H19V35H32V37L35 34ZM23.5 27.8H28.5L29.4 30H31.5L26.75 19H25.25L20.5 30H22.6L23.5 27.8ZM26 20.98L27.87 26H24.13L26 20.98Z"
      fill="#FBAD33"
    />
  </svg>
);
export const FileUploadIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M24 32.5H30V26.5H34L27 19.5L20 26.5H24V32.5ZM27 22.33L29.17 24.5H28V30.5H26V24.5H24.83L27 22.33ZM20 34.5H34V36.5H20V34.5Z"
      fill="#FBAD33"
    />
  </svg>
);
export const ImageUploadIcon = (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" transform="translate(0.5)" fill="#FFF4E3" />
    <path
      d="M33 36.5H19V22.5H28V20.5H19C17.9 20.5 17 21.4 17 22.5V36.5C17 37.6 17.9 38.5 19 38.5H33C34.1 38.5 35 37.6 35 36.5V27.5H33V36.5ZM25.21 33.33L23.25 30.97L20.5 34.5H31.5L27.96 29.79L25.21 33.33ZM35 20.5V17.5H33V20.5H30C30.01 20.51 30 22.5 30 22.5H33V25.49C33.01 25.5 35 25.49 35 25.49V22.5H38V20.5H35Z"
      fill="#FBAD33"
    />
  </svg>
);
export const DateIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M22 27H24V29H22V27ZM36 22V36C36 37.1 35.1 38 34 38H20C18.89 38 18 37.1 18 36L18.01 22C18.01 20.9 18.89 20 20 20H21V18H23V20H31V18H33V20H34C35.1 20 36 20.9 36 22ZM20 24H34V22H20V24ZM34 36V26H20V36H34ZM30 29H32V27H30V29ZM26 29H28V27H26V29Z"
      fill="#FBAD33"
    />
  </svg>
);
export const YesNoNaIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <path
      d="M31.4502 27.035L27.9102 23.495L29.3202 22.085L31.4402 24.205L35.6802 19.965L37.0902 21.375L31.4502 27.035ZM25.9102 23.035H16.9102V25.035H25.9102V23.035ZM35.9102 29.445L34.5002 28.035L31.9102 30.625L29.3202 28.035L27.9102 29.445L30.5002 32.035L27.9102 34.625L29.3202 36.035L31.9102 33.445L34.5002 36.035L35.9102 34.625L33.3202 32.035L35.9102 29.445ZM25.9102 31.035H16.9102V33.035H25.9102V31.035Z"
      fill="#FBAD33"
    />
  </svg>
);

export const MultipleChoiceIcon = (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" transform="translate(0.5)" fill="#FFF4E3" />
    <path
      d="M37.5 23.5348L28.5 23.5348V25.5348L37.5 25.5348V23.5348ZM37.5 31.5348L28.5 31.5348V33.5348H37.5V31.5348ZM21.04 27.5348L17.5 23.9948L18.91 22.5848L21.03 24.7048L25.27 20.4648L26.68 21.8748L21.04 27.5348ZM21.04 35.5348L17.5 31.9948L18.91 30.5848L21.03 32.7048L25.27 28.4648L26.68 29.8748L21.04 35.5348Z"
      fill="#FBAD33"
    />
  </svg>
);

export const CheckBoxIcon = (
  <svg
    width="54"
    height="56"
    viewBox="0 0 54 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" fill="#FFF4E3" />
    <g clipPath="url(#clip0_391_24077)">
      <path
        d="M34 21L20 21L20 35L34 35L34 21ZM36 21L36 35C36 36.1 35.1 37 34 37L20 37C18.9 37 18 36.1 18 35L18 21C18 19.9 18.9 19 20 19L34 19C35.1 19 36 19.9 36 21Z"
        fill="#FBAD33"
      />
    </g>
    <defs>
      <clipPath id="clip0_391_24077">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 39 40)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const RadioGroupIcon = (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" transform="translate(0.5)" fill="#FFF4E3" />
    <path
      d="M27.5 18C21.98 18 17.5 22.48 17.5 28C17.5 33.52 21.98 38 27.5 38C33.02 38 37.5 33.52 37.5 28C37.5 22.48 33.02 18 27.5 18ZM27.5 36C23.08 36 19.5 32.42 19.5 28C19.5 23.58 23.08 20 27.5 20C31.92 20 35.5 23.58 35.5 28C35.5 32.42 31.92 36 27.5 36Z"
      fill="#FBAD33"
    />
    <path
      d="M27.5 33C30.2614 33 32.5 30.7614 32.5 28C32.5 25.2386 30.2614 23 27.5 23C24.7386 23 22.5 25.2386 22.5 28C22.5 30.7614 24.7386 33 27.5 33Z"
      fill="#FBAD33"
    />
  </svg>
);

export const DropdownIcon = (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" transform="translate(0.5)" fill="#FFF4E3" />
    <path
      d="M30.58 25.59L27.5 28.67L24.42 25.59L23 27L27.5 31.5L32 27L30.58 25.59ZM27.5 18C21.98 18 17.5 22.48 17.5 28C17.5 33.52 21.98 38 27.5 38C33.02 38 37.5 33.52 37.5 28C37.5 22.48 33.02 18 27.5 18ZM27.5 36C23.08 36 19.5 32.42 19.5 28C19.5 23.58 23.08 20 27.5 20C31.92 20 35.5 23.58 35.5 28C35.5 32.42 31.92 36 27.5 36Z"
      fill="#FBAD33"
    />
  </svg>
);
export const SignatureIcon = (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" transform="translate(0.5)" fill="#FFF4E3" />
    <path
      d="M25.2802 20V21.38C24.4502 21.05 23.5602 20.88 22.6702 20.88C20.8802 20.88 19.0902 21.56 17.7202 22.93L21.0502 26.26H22.1602V27.37C23.0202 28.23 24.1402 28.68 25.2702 28.73V31H22.2802V34C22.2802 35.1 23.1802 36 24.2802 36H34.2802C35.9402 36 37.2802 34.66 37.2802 33V20H25.2802ZM24.1702 26.41V24.26H21.8902L20.8502 23.22C21.4202 23 22.0402 22.88 22.6702 22.88C24.0102 22.88 25.2602 23.4 26.2102 24.34L27.6202 25.75L27.4202 25.95C26.9102 26.46 26.2302 26.75 25.5002 26.75C25.0302 26.75 24.5702 26.63 24.1702 26.41ZM35.2802 33C35.2802 33.55 34.8302 34 34.2802 34C33.7302 34 33.2802 33.55 33.2802 33V31H27.2802V28.41C27.8502 28.18 28.3802 27.84 28.8402 27.38L29.0402 27.18L31.8702 30H33.2802V28.59L27.2802 22.62V22H35.2802V33Z"
      fill="#FBAD33"
    />
  </svg>
);
export const AlertIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 16.125H17.25L9 1.875L0.75 16.125ZM9.75 13.875H8.25V12.375H9.75V13.875ZM9.75 10.875H8.25V7.875H9.75V10.875Z"
      fill="#F44336"
    />
  </svg>
);
export const InfoIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
      fill="#FBAD33"
    />
  </svg>
);
export const DraftIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 4.5H9L7.5 3H3C2.175 3 1.5 3.675 1.5 4.5V13.5C1.5 14.325 2.175 15 3 15H15C15.825 15 16.5 14.325 16.5 13.5V6C16.5 5.175 15.825 4.5 15 4.5ZM15 13.5H3V4.5H6.8775L8.3775 6H15V13.5ZM9.12 9H6V10.5H9.12L7.9275 11.6925L8.9925 12.75L12 9.7575L8.9925 6.75L7.935 7.8075L9.12 9Z"
      fill="#5F6D83"
    />
  </svg>
);

export const WarningIcon = (
  <svg
    width="46"
    height="40"
    viewBox="0 0 46 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.42963 39.8424H40.5696C44.163 39.8424 46.403 35.9457 44.6063 32.8424L27.0363 2.4857C25.2396 -0.61763 20.7596 -0.61763 18.963 2.4857L1.39297 32.8424C-0.403701 35.9457 1.8363 39.8424 5.42963 39.8424ZM22.9996 23.509C21.7163 23.509 20.6663 22.459 20.6663 21.1757V16.509C20.6663 15.2257 21.7163 14.1757 22.9996 14.1757C24.283 14.1757 25.333 15.2257 25.333 16.509V21.1757C25.333 22.459 24.283 23.509 22.9996 23.509ZM25.333 32.8424H20.6663V28.1757H25.333V32.8424Z"
      fill="#FBAD33"
    />
  </svg>
);
export const TimeIcon = (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="54" height="56" transform="translate(0.5)" fill="#FFF4E3" />
    <path
      d="M27.49 18C21.97 18 17.5 22.48 17.5 28C17.5 33.52 21.97 38 27.49 38C33.02 38 37.5 33.52 37.5 28C37.5 22.48 33.02 18 27.49 18ZM27.5 36C23.08 36 19.5 32.42 19.5 28C19.5 23.58 23.08 20 27.5 20C31.92 20 35.5 23.58 35.5 28C35.5 32.42 31.92 36 27.5 36ZM28 23H26.5V29L31.75 32.15L32.5 30.92L28 28.25V23Z"
      fill="#FBAD33"
    />
  </svg>
);

export const PermissionInfoIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 11.75C7.5875 11.75 7.25 11.4125 7.25 11V8C7.25 7.5875 7.5875 7.25 8 7.25C8.4125 7.25 8.75 7.5875 8.75 8V11C8.75 11.4125 8.4125 11.75 8 11.75ZM8.75 5.75H7.25V4.25H8.75V5.75Z"
      fill="#F0840F"
    />
  </svg>
);

export const SimpleTableIcon = (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" fill="#FFF4E3" />
    <path
      d="M 35.160156 19.410156 L 20.839844 19.410156 C 19.789062 19.410156 18.933594 20.269531 18.933594 21.316406 L 18.933594 34.683594 C 18.933594 35.730469 19.789062 36.589844 20.839844 36.589844 L 35.160156 36.589844 C 36.210938 36.589844 37.066406 35.730469 37.066406 34.683594 L 37.066406 21.316406 C 37.066406 20.269531 36.210938 19.410156 35.160156 19.410156 Z M 35.160156 21.316406 L 35.160156 24.183594 L 20.839844 24.183594 L 20.839844 21.316406 Z M 30.386719 34.683594 L 25.613281 34.683594 L 25.613281 26.089844 L 30.386719 26.089844 Z M 20.839844 26.089844 L 23.703125 26.089844 L 23.703125 34.683594 L 20.839844 34.683594 Z M 32.296875 34.683594 L 32.296875 26.089844 L 35.160156 26.089844 L 35.160156 34.683594 Z M 32.296875 34.683594 "
      fill="#FBAD33"
    />
  </svg>
);

export const AdvancedTableIcon = (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" fill="#FFF4E3" />
    <path
      d="M 35.636719 18.453125 L 20.363281 18.453125 C 19.3125 18.453125 18.453125 19.3125 18.453125 20.363281 L 18.453125 35.636719 C 18.453125 36.6875 19.3125 37.546875 20.363281 37.546875 L 35.636719 37.546875 C 36.6875 37.546875 37.546875 36.6875 37.546875 35.636719 L 37.546875 20.363281 C 37.546875 19.3125 36.6875 18.453125 35.636719 18.453125 Z M 24.183594 35.636719 L 20.363281 35.636719 L 20.363281 31.816406 L 24.183594 31.816406 Z M 24.183594 29.910156 L 20.363281 29.910156 L 20.363281 26.089844 L 24.183594 26.089844 Z M 24.183594 24.183594 L 20.363281 24.183594 L 20.363281 20.363281 L 24.183594 20.363281 Z M 29.910156 35.636719 L 26.089844 35.636719 L 26.089844 31.816406 L 29.910156 31.816406 Z M 29.910156 29.910156 L 26.089844 29.910156 L 26.089844 26.089844 L 29.910156 26.089844 Z M 29.910156 24.183594 L 26.089844 24.183594 L 26.089844 20.363281 L 29.910156 20.363281 Z M 35.636719 35.636719 L 31.816406 35.636719 L 31.816406 31.816406 L 35.636719 31.816406 Z M 35.636719 29.910156 L 31.816406 29.910156 L 31.816406 26.089844 L 35.636719 26.089844 Z M 35.636719 24.183594 L 31.816406 24.183594 L 31.816406 20.363281 L 35.636719 20.363281 Z M 35.636719 24.183594 "
      fill="#FBAD33"
    />
  </svg>
);
